export default "__VITE_ASSET__DKPzwKhi__"